import React, { useContext } from 'react';
import { Button, Steps } from 'antd';
import './styles.less';
import { ArrowLeftOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import steps from '../../../steps';
import { EnrollmentContext } from '../../../../../providers/EnrollmentContextProvider';
import Text from '../../../../../components/common/Text';

const EnrollmentProgressStepper = ({ onBack }) => {
  const { currentStep, currentStepIndex } = useContext(EnrollmentContext);

  return (
    <div className="enrollment-steps">
      {currentStepIndex > 0 && currentStepIndex < steps.length - 1 && (
        <Button type="link" className="enrollment-steps-back-button" onClick={onBack}>
          <ArrowLeftOutlined />{' '}
          <Text underline className="enrollment-steps-back-button__label">
            Volver atrás
          </Text>
        </Button>
      )}
      <h2 className="enrollment-steps__title">{currentStep.title}</h2>
      <p className="enrollment-steps__description">{currentStep.description}</p>
      <Steps direction="vertical" current={currentStepIndex}>
        {steps.slice(0, steps.length - 1).map((step) => (
          <Steps.Step key={step.title} title={step.title} />
        ))}
      </Steps>
    </div>
  );
};

EnrollmentProgressStepper.propTypes = {
  onBack: PropTypes.func.isRequired,
};

export default EnrollmentProgressStepper;
